// @ts-nocheck
import React from 'react';

const PurchaseOrderOpenAlert = React.lazy(
  () => import('@/containers/Alerts/PurchaseOrders/PurchaseOrderOpenAlert'),
);
const PurchaseOrderDeleteAlert = React.lazy(
  () => import('@/containers/Alerts/PurchaseOrders/PurchaseOrderDeleteAlert'),
);

// const BillLocatedLandedCostDeleteAlert = React.lazy(
//   () => import('@/containers/Alerts/Bills/BillLocatedLandedCostDeleteAlert'),
// );

export default [
  { name: 'purchase-order-delete', component: PurchaseOrderDeleteAlert },
  { name: 'purchase_order-open', component: PurchaseOrderOpenAlert },
  // {
 
  //   name: 'bill-located-cost-delete',
  //   component: BillLocatedLandedCostDeleteAlert,
  // },
];
